/* Pairing list helpers for the package builder.
   Page length is snippets/ahri-package-builder.liquid `package_page_size`.
   Search fields are the haystack in that snippet: furnace, coil, air_handler, indoor
   (model, sku, title, handle). This file only formats the request and the pager. */
(function (root) {
  var PAGE_SIZE = 5;
  var SEARCH_DEBOUNCE_MS = 300;

  function requestToken(handle, page, query) {
    var clean = String(query || '')
      .replace(/\|\|\|/g, ' ')
      .trim();
    var number = Number(page);
    if (!number || number < 1) number = 1;
    return [String(handle || '').trim(), String(number), clean].join('|||');
  }

  function pagerState(page, pages, loading) {
    var current = Number(page) || 1;
    var known = pages == null || pages === '' ? null : Number(pages);
    var busy = Boolean(loading);
    return {
      prevDisabled: busy || current <= 1,
      nextDisabled: busy || known == null || known < 1 || current >= known,
    };
  }

  function statusText(copy, state) {
    var text = copy || {};
    var pageLine = String(text.page || 'Page {{ page }} of {{ pages }}')
      .replace('{{ page }}', String(state.page))
      .replace('{{ pages }}', String(state.pages));
    var countLine =
      Number(state.total) === 1
        ? String(text.one || '1 pairing.')
        : String(text.count || '{{ count }} pairings.').replace('{{ count }}', String(state.total));
    return pageLine.replace(/\.\s*$/, '') + '. ' + countLine;
  }

  function debounce(fn, wait) {
    var generation = 0;
    function debounced() {
      var args = arguments;
      var context = this;
      generation += 1;
      var current = generation;
      setTimeout(function () {
        if (current !== generation) return;
        fn.apply(context, args);
      }, wait);
    }
    debounced.cancel = function cancel() {
      generation += 1;
    };
    return debounced;
  }

  var api = {
    PAGE_SIZE: PAGE_SIZE,
    SEARCH_DEBOUNCE_MS: SEARCH_DEBOUNCE_MS,
    requestToken: requestToken,
    pagerState: pagerState,
    statusText: statusText,
    debounce: debounce,
  };

  root.AhriPackagePage = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
